'use client';

import type { FC } from 'react';
import { QuickEditToolForm } from '../_components/quick-edit/QuickEditToolForm';

const VideoEditForm: FC = () => {
  return <QuickEditToolForm mode="video" />;
};

export default VideoEditForm;
